import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { ImportBookingRequest } from '../../types/auth.js'
import type { MyBookingDetail } from '../../types/booking.js'

import { apiClient } from '../../lib/client.js'
import { bookingKeys } from './keys.js'

export const useImportBookingMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: ImportBookingRequest) => {
      const response = await apiClient.client.post<MyBookingDetail>('/me/bookings/import', data)
      return response.data
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: bookingKeys.myBookings })
    },
  })
}
